module.exports = __webpack_public_path__ + "img/gamecare.f573892b.svg";